export const ASSIGN_BACK_ERROR_MESSAGE = 'Unable to assign the document back to the assigner. Please try again.';

export const assignBackThenComplete = async ({
  assignedDocumentId,
  assignBackAndComplete,
}) => {
  const response = await assignBackAndComplete(assignedDocumentId);
  if (response?.error || response?.canceled) {
    return { ok: false, stage: 'assign_back_and_complete', response };
  }

  return { ok: true };
};
